import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { NzMessageService } from 'ng-zorro-antd/message';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Subject, takeUntil } from 'rxjs';
import { BaseService } from 'src/app/services/base.service';
import { LIST_KEY } from 'src/app/constants/endpoint.const';
import { IMobileKey } from 'src/app/models/integration.model';
import { ModalAddMobKeyComponent } from '../modal-add-mob-key/modal-add-mob-key.component';
import { ModalDeleteReferrerComponent } from '../modal-delete-referrer/modal-delete-referrer.component';

@Component({
  standalone: false,
  selector: 'app-mobile-key',
  templateUrl: './mobile-key.component.html',
  styleUrls: ['./mobile-key.component.scss'],
})
export class MobileKeyComponent implements OnInit {
  @Output() deleted = new EventEmitter<void>();

  destroy$ = new Subject();
  listMobileKey: IMobileKey[] = [];
  loading: boolean = true;

  constructor(
    private message: NzMessageService,
    private modalService: NgbModal,
    private baseService: BaseService
  ) {}

  ngOnInit(): void {
    this.getListKey();
    setTimeout(() => {
      this.loading = false;
    }, 1000);
  }

  getListKey() {
    this.baseService
      .getData(LIST_KEY)
      .pipe(takeUntil(this.destroy$))
      .subscribe(
        (res) => {
          this.listMobileKey = res.data;
        },
        (err) => {
          this.message.create('error', 'Failed to get list Mobile Key Android');
          console.warn(err);
        }
      );
  }

  addMobileKey() {
    const modal = this.modalService.open(ModalAddMobKeyComponent, {
      size: 'md',
      centered: true,
      backdrop: 'static',
    });

    const modalInstance = modal.componentInstance as ModalAddMobKeyComponent;

    modalInstance.addMobKey.subscribe(() => {
      this.getListKey();
    });
  }

  deleteReferrer(e: number, d: string) {
    const modal = this.modalService.open(ModalDeleteReferrerComponent, {
      size: 'md',
      centered: true,
      backdrop: 'static',
      keyboard: false,
    });

    const modalInstance =
      modal.componentInstance as ModalDeleteReferrerComponent;

    modal.componentInstance.idRef = e;
    modal.componentInstance.typeDevice = d;

    modalInstance.deleteRef.subscribe(() => {
      this.getListKey();
      this.deleted.emit();
    });
  }

  deviceType(e: string) {
    if (e === 'android' || e === 'Android') return 'Android';
    else return 'iOS';
  }

  classdeviceType(e: string) {
    if (e === 'android' || e === 'Android') return 'android';
    else return 'ios';
  }
}
